// Copyright (C) Digital Jetty Konrad Gadzinowski - All Rights Reserved

import { isSupported, getMessaging, getToken } from "firebase/messaging"
import { initializeApp, getApps } from "firebase/app"

export class PushNotifications {

  private static readonly SERVICE_WORKER_URL = "/firebase-messaging-sw.js"
  private static readonly FIREBASE_APP_NAME = "restanaut"

  public static setup = async (): Promise<void> => {
    try {
      if (!("serviceWorker" in navigator) || !("Notification" in window) || !("PushManager" in window)) return

      const response = await fetch("/api/v1/push/config")
      if (!response.ok) return
      const { enabled, config, vapidKey } = await response.json()
      if (!enabled || !config?.apiKey || !vapidKey) return

      if (!(await isSupported())) return

      if (Notification.permission === "denied") return
      if (Notification.permission === "default") {
        const permission = await Notification.requestPermission()
        if (permission !== "granted") return
      }

      const registration = await navigator.serviceWorker.register(PushNotifications.SERVICE_WORKER_URL)

      const app = getApps().find((existing) => existing.name === PushNotifications.FIREBASE_APP_NAME)
        ?? initializeApp(config, PushNotifications.FIREBASE_APP_NAME)

      const messaging = getMessaging(app)
      const token = await getToken(messaging, { vapidKey, serviceWorkerRegistration: registration })
      if (!token) return

      const csrf = document.querySelector<HTMLInputElement>('input[name="_csrf"]')?.value ?? ""
      await fetch("/api/v1/push/register", {
        method: "POST",
        headers: { "Content-Type": "application/json", "X-CSRF-Token": csrf },
        body: JSON.stringify({ token }),
      })
    } catch (error) {
      // Best-effort: ignore push setup failures so they never disrupt the orders page.
    }
  }
}
